// extracted by mini-css-extract-plugin
export default {"divider":"PositionDivider_divider__c+JcL","childrenContainer":"PositionDivider_childrenContainer__RM09m"};